import type { Project } from './types/project';

/**
 * Formats a project display name from its metadata fields.
 * Uses the assigned client name (clientName) from the clients table.
 * In portal mode, endClient replaces the client name when present.
 *
 * With site number:    "Client 1234 - City, State"
 * Without site number: "Client - Address, City, State"
 * Fallback:            project.name
 */
export function formatProjectName(
  p: Pick<Project, 'name' | 'endClient' | 'siteNumber' | 'address' | 'city' | 'state'> & { clientName?: string },
  opts?: { portal?: boolean },
): string {
  const clientName = (p as any).clientName;
  // In portal mode, show endClient instead of client when available
  const clientLabel = opts?.portal && p.endClient ? p.endClient : clientName;
  const location = [p.city, p.state].filter(Boolean).join(', ');

  if (p.siteNumber) {
    const parts = [clientLabel, p.siteNumber].filter(Boolean).join(' ');
    return location ? `${parts} - ${location}` : parts;
  }

  // Without site number: "Client - Address, City, State"
  const fullLocation = [p.address, p.city, p.state].filter(Boolean).join(', ');
  if (clientLabel && fullLocation) return `${clientLabel} - ${fullLocation}`;
  return clientLabel || fullLocation || p.name;
}
